var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[(_vm.showMobile)?_c('MobileHeader'):_c('Header'),_c('div',{class:_vm.showMobile ? 'mobile-main' : 'main'},[_c('div',{class:_vm.showMobile ? 'mobile-view' : 'main'},[_c('router-view')],1),(_vm.showMobile)?_c('MobileFooter'):_vm._e()],1),(!_vm.showMobile)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }